import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-result-info',
    templateUrl: './modal-result-info.component.html',
    styleUrls: ['./modal-result-info.component.scss'],
})
export class ModalResultInfoComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<ModalResultInfoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {}

    closeDialog() {
        this.dialogRef.close(false);
    }
}
